import { EllipsisHorizontalIcon } from '@heroicons/react/24/outline';
import { IActionsBarProps } from '../actions-bar/actions-bar.types';
import { Breadcrumbs } from '../breadcrumbs/breadcrumbs';
import { BreadcrumbsProps } from '../breadcrumbs/breadcrumbs.types';
import { Button } from '../button/button';
import styles from './page-title.module.css';
import { ContextMenu } from '../context-menu/context-menu';
import classNames from 'classnames';
import { IContextMenuItem } from '../context-menu/context-menu.types';

export const PageTitle = ({
  title,
  allowDelete = false,
  allowSave = false,
  allowCreate = false,
  onAction,
  furtherActions,
  ...props
}: { title: string; allowCreate?: boolean } & BreadcrumbsProps &
  IActionsBarProps) => {
  const handleClick = (action: string) => {
    onAction?.(action);
  };
  return (
    <div
      className={classNames(styles.pageTitle, {
        [styles['pageTitle--withButton']]:
          allowSave && !allowDelete && !(furtherActions?.length ?? 0),
        [styles['pageTitle--withFurtherActions']]:
          !allowSave && (allowDelete || (furtherActions?.length ?? 0)),
        [styles['pageTitle--withButtonAndFurtherActions']]:
          allowSave && (allowDelete || (furtherActions?.length ?? 0)),
      })}
    >
      <h2 className={styles.title}>{title}</h2>
      {allowDelete || furtherActions?.length ? (
        <ContextMenu
          items={[
            ...(allowDelete
              ? [
                  {
                    display: 'Delete',
                    value: 'delete',
                    type: 'danger',
                    action: () => {
                      handleClick('delete');
                    },
                  } as IContextMenuItem,
                ]
              : []),
            ...(allowCreate
              ? [
                  {
                    display: 'Create',
                    value: 'create',
                    action: () => {
                      handleClick('create');
                    },
                  },
                ]
              : []),
            ...(furtherActions?.map((fa) => ({
              ...fa,
              action: () => handleClick(fa.value),
            })) ?? []),
          ]}
        >
          <EllipsisHorizontalIcon height={24} />
        </ContextMenu>
      ) : null}
      {allowSave && (
        <Button onClick={() => handleClick('save')} className={styles.button}>
          Save
        </Button>
      )}
      <Breadcrumbs className={styles.crumbs} {...props} />
    </div>
  );
};
